// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__HRP9k","clinicsSelect":"TableHeading_clinicsSelect__34aKO"};